import React from "react";
import PropTypes from "prop-types";
import styles from "components/upload-documents/processing-fields.scss";
import { ReceiptFields } from "components/upload-documents/receipt-fields";
import { OtherFields } from "components/upload-documents/other-fields";
import moment from "moment";
import { documentPropType } from "custom-prop-types";
import { capitalize } from "utils/string-helpers";
import { Select } from "components/common/select";


export const ProcessingFields = (props) => {
  const { focusedDocument } = props;
  const newCurrency = focusedDocument.currency || props.preferredCurrency;
  const initialValues = {
    categories: focusedDocument.categories || [],
    cardNumber: null,
    currency: { key: newCurrency, name: newCurrency },
    formPaymentType: { key: "credit-card", name: "Card" },
    invoiceNumber: focusedDocument.invoiceNumber || "",
    issued: focusedDocument.issued || "",
    notes: focusedDocument.notes || "",
    tax: focusedDocument.tax || 0,
    total: focusedDocument.total || 0,
    vendor: focusedDocument.vendor || ""
  };

  if (focusedDocument !== null) {
    if (props.documentType === "receipt") {
      return (
        <div className={ styles["fields-container"] }>
          <ReceiptFields
            { ...props }
            dateSelection={ dateSelection }
            initialValues={ initialValues }
            makeMomentObj={ makeMomentObj }
            valueMapper={ valueMapper }
          />
        </div>
      );
    }
    return (
      <div className={ styles["fields-container"] }>
        <OtherFields
          { ...props }
          dateSelection={ dateSelection }
          makeMomentObj={ makeMomentObj }
          valueMapper={ valueMapper }
        />
      </div>
    );
  }
  return null;
};

ProcessingFields.defaultProps = {
  focusedDocument: null
};

ProcessingFields.propTypes = {
  documentType: PropTypes.string.isRequired,
  focusedDocument: documentPropType,
  preferredCurrency: PropTypes.string.isRequired
};

const documentTypes = [
  { key: "receipt", name: "Receipt" },
  { key: "other", name: "Other" }
];

const valueMapper = (value) => ({ name: value, key: value });
const makeMomentObj = (date) => moment(date);
const dateSelection = (e, onUpdateDocument) => {
  const momentInstance = e === null ? moment() : moment(e);
  onUpdateDocument("issued", momentInstance.utc().format());
};

export const DocumentTypeSelector = ({ documentType, onChangeDocumentType }) => (
  <div className={ styles.section }>
    <h4>Document type</h4>
    <div className={ styles["fields-wrapper"] }>
      <Select
        clearable={ false }
        data={ documentTypes }
        onChange={ (e) => { onChangeDocumentType(e.key); } }
        placeholder="Choose a document type"
        value={ valueMapper(capitalize(documentType)) }
      />
    </div>
  </div>
);

DocumentTypeSelector.propTypes = {
  documentType: PropTypes.string.isRequired,
  onChangeDocumentType: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/processing-fields.jsx